var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93363 1.91325C8.55322 1.13992 7.45408 1.13992 7.07366 1.91325L5.49327 5.12601L1.95939 5.6412C1.10876 5.76521 0.769109 6.81399 1.38463 7.41595L3.94177 9.91674L3.33811 13.4479C3.1928 14.2979 4.08203 14.9461 4.84285 14.5448L8.00365 12.8776L11.1644 14.5448C11.9253 14.9461 12.8145 14.2979 12.6692 13.4479L12.0655 9.91674L14.6227 7.41595C15.2382 6.81399 14.8985 5.76521 14.0479 5.6412L10.514 5.12601L8.93363 1.91325Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackBookmark);
export default __webpack_public_path__ + "static/media/BlackBookmark.dd8cd7cd0b40c11fa59dba93b782949b.svg";
export { ForwardRef as ReactComponent };